<template>
  <div>
    <Timepicker
      :appointment="appointment"
      :backdate="backdate"
      :show-notify-toggle="showNotifyToggle"
      @request-save="onRequestSave"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Timepicker from "@/components/Seranova/Timepicker/Timepicker.vue";
import { useBreakpoints } from "@/composables/useBreakpoints";
import { AppointmentV2 } from "@/typings/appointment";

const emit = defineEmits(["request-save"]);
const props = defineProps<{ appointment: AppointmentV2; backdate?: boolean }>();

const { type } = useBreakpoints();

// The tenant-scoped rollout flag for this hasn't landed yet, so the gate is
// breakpoint-only for now. Fold it back in once the flag plumbing exists:
// import { useFeatureFlag } from "@/lib/useFeatureFlag";
// const mobileWebOptimizationEnabled = useFeatureFlag("mobile_web_optimization");
const showNotifyToggle = computed(
  () => !props.backdate && type.value === "mobile"
  // && mobileWebOptimizationEnabled.value
);

const onRequestSave = (data: { action: string; payload: object }) => {
  emit("request-save", data);
};
</script>

<style scoped></style>
